<div class="ResInfoPanel apptBookerComponent">
  <div *ngIf="appointmentState === 0" class="resource-search-container">
    <dx-text-box
      mode="search"
      [height]="34"
      width="100%"
      placeholder="Search for resource by name"
      (onInput)="onResourceSearchInput($event)"
      [disabled]="!resources?.length"
    >
    </dx-text-box>
  </div>
  <dx-tile-view
    *ngIf="!(resourceSearchActive && !_resources?.length)"
    apptBookerComponent
    ng-star-inserted
    MakeSalePanel
    #resourcePanel
    id="resourcePanel"
    [items]="_resources"
    direction="vertical"
    [baseItemHeight]="100"
    [baseItemWidth]="100"
    [elementAttr]="{ class: 'resource-panel' }"
    [itemMargin]="10"
    itemTemplate="list-item"
    [height]="220"
    width="100%"
    showScrollbar="always"
    noDataText=""
    (onContentReady)="onContentReady($event)"
  >
    <div *dxTemplate="let data of 'list-item'; let index = index">
      <div
        class="resource"
        (click)="itemClicked(data)"
        [class.selected]="data.Selected"
        [class.no-status]="!data.State"
        [class.dirty]="data?.State === 'BedDirty'"
        [class.ready]="data?.State === 'Ready'"
        [class.other-status]="data.State?.length && data.State !== 'BedDirty' && data.State !== 'Ready'"
      >
        <div class="resourceName">{{ data.ResourceName }}</div>
        <div *ngIf="showWaitTime">
          <div *ngIf="data.WaitTime >= 0" class="resourceWait">{{ data.WaitTime | durationFormat : 'm' : 'HHMM' }}</div>
          <div *ngIf="data.WaitTime == undefined || data.WaitTime < 0" class="resourceWait">Unavailable</div>
        </div>
        <div *ngIf="showCustomText">
          <div class="resourceWait">{{ data.CustomText }}</div>
        </div>
        <div *ngIf="showCustomText == false && showWaitTime == false">
          <div class="resourceWait">&nbsp;</div>
        </div>
        <div
          *ngIf="
            showWarnings && (data?.SkinTypeDisclaimerRequired == true || data?.SafetyPolicyDisclaimerRequired == true)
          "
          class="resourceDisclaimer"
        >
          <img src="/images/signature_1.svg" height="30" width="30" />
        </div>
      </div>
    </div>
  </dx-tile-view>
  <div *ngIf="resourceSearchActive && !_resources?.length" class="no-results-message">No results found</div>
  <dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="showLoading"
    [showIndicator]="true"
    [position]="{ of: '#resourcePanel' }"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  >
  </dx-load-panel>
</div>
